import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { LayoutProvider, MasterInit } from 'ufinet-web-components'

const App = () => {
	return (
		<LayoutProvider>
			<Outlet />
			<MasterInit />
			<ToastContainer />
		</LayoutProvider>
	)
}

export { App }
